export default __webpack_public_path__ + "img/chefsmaak-logo-circular.07f7f8a906b2c2668a451f3d4f954aab.png";